export default __webpack_public_path__ + "static/media/language.74e9027e.svg";